<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-layout
      row
      wrap
    >
      <v-flex>
        <v-card class="max-shadow">
          <v-card-title>
            <div class="title-2">
              Recurring Invoices
            </div>
            <v-spacer />
            <v-card-actions>
              <v-btn
                flat
                color="primary"
                @click="invoiceEditorDialog = true"
              >
                Create
              </v-btn>
            </v-card-actions>
          </v-card-title>
          <v-data-table
            id="invoicesTable"
            :headers="invoicesHeaders"
            :items="recurringInvoices"
            :loading="invoicesLoading"
            item-key="id"
            no-data-text="No invoices found"
            class="px-2 pb-2"
            disable-initial-sort
            hide-actions
          >
            <v-progress-linear
              slot="progress"
              color="primary"
              indeterminate
            />
            <template
              slot="items"
              slot-scope="props"
            >
              <tr
                class=" row-border"
                style="cursor: pointer;"
                @click="previewInvoice(props.item)"
              >
                <td style="width: 20px">
                  {{ props.index + 1 }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.name }}
                </td>
                <td class="text-xs-left">
                  {{ formatDate(props.item.startDate.toDate()) }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.neverExpires ? 'Never Expires' : props.item.cycles }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.repeatEvery + ' ' + props.item.cycleUnit }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.total }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="invoiceEditorDialog"
        scrollable
        persistent
        lazy
      >
        <v-card class="max-shadow">
          <v-card-title class="title">
            New Invoice
          </v-card-title>
          <v-divider />
          <new-recurring-invoice
            v-if="invoiceEditorDialog"
            ref="newRecurringInvoice"
            :tenant="tenant"
          />
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              flat
              @click.native="invoiceEditorDialog = false"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              flat
              @click.native="createRecurringInvoice"
            >
              Create
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="invoicePreviewDialog"
        scrollable 
        persistent
        lazy
      >
        <invoice-preview 
          :invoice="selectedInvoice"
          type="recurringInvoice"
          @close="invoicePreviewDialog = false"
        />
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';
import moment from 'moment';

import NewRecurringInvoice from './NewRecurringInvoice';
import InvoicePreview from '@/components/max-admin/tenants/InvoicePreview';

export default {
  name: 'RecurringInvoices',
  components: {
    'new-recurring-invoice': NewRecurringInvoice,
    'invoice-preview': InvoicePreview
  },
  props: {
    tenantId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tenant: {
        admin: {},
        billingSettings: {},
        invoiceSettings: {}
      },
      recurringInvoices: [],
      invoicesLoading: false,
      selectedInvoice: {},
      invoicesHeaders: [
        {
          text: '#',
          value: false,
          align: 'left',
          width: '10px'
        },
        {
          text: 'Name',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Start Date',
          value: 'startDate',
          align: 'left'
        },
        {
          text: 'Cycles',
          value: 'cycles',
          align: 'left'
        },
        {
          text: 'Cycle Duration',
          value: 'repeatEvery',
          align: 'left'
        },
        {
          text: 'Amount',
          value: 'total',
          align: 'left'
        }
      ],
      invoiceEditorDialog: false,
      invoicePreviewDialog: false
    };
  },
  created() {
    // fetch tenant details
    firestore
      .collection('tenants')
      .doc(this.tenantId)
      .get()
      .then(tenantSnapshot => {
        this.tenant = tenantSnapshot.data();
      });

    this.fetchRecurringInvoices();
  },
  methods: {
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },

    createRecurringInvoice() {
      const invoice = this.$refs.newRecurringInvoice.validate();
      if (!invoice) return;

      firestore
        .collection('tenants')
        .doc(this.tenantId)
        .collection('recurringInvoices')
        .add(invoice)
        .then(() => {
          this.invoiceEditorDialog = false;
          this.fetchRecurringInvoices();
        })
        .catch(error => {
          console.log(error);
        });
    },

    fetchRecurringInvoices() {
      //fetch invoices
      firestore
        .collection('tenants')
        .doc(this.tenantId)
        .collection('recurringInvoices')
        .get()
        .then(invoicesSnapshot => {
          this.recurringInvoices = [];
          invoicesSnapshot.forEach(invoiceSnap => {
            this.recurringInvoices.push(invoiceSnap.data());
          });
        })
        .catch(error => {
          //TODO: handle errors wherever there are not handled
          console.log(error);
        });
    },

    previewInvoice(invoice) {
      this.selectedInvoice = invoice;
      this.invoicePreviewDialog = true;
    }
  }
};
</script>

<style scoped>
</style>
